<template>
    <form-text-box
        ref="authFormRef"
        :column="1"
        :dataList="configList"
        :rules="rules"
        :model="model"
        :formProps="{ labelWidth: '260px' }"
    ></form-text-box>
</template>

<script>
import { addContractOrg } from '@/api/domain/organize'

export default {
  name: 'addOrg',
  props: {
    orgName: {
      type: String,
      default: '',
    },
    orgIdCardNum: {
      type: String,
      default: '',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      configList: [
        {
          el: 'input',
          itemConfig: {
            label: '企业主体全称',
            prop: 'orgName',
          },
          elConfig: {
            placeholder: '请输入企业主体全称',
            maxlength: 50,
            disabled: this.disabled,
            style: {
              width: '230px',
            },
          },
        },
        {
          el: 'input',
          itemConfig: {
            label: '统一社会信用代码证号',
            prop: 'orgIdCardNum',
          },
          elConfig: {
            placeholder: '请输入统一社会信用代码证号',
            maxlength: 18,
            disabled: this.disabled,
            style: {
              width: '230px',
            },
            events: {
              input: (value) => {
                const regex = /^[A-Z0-9]{0,18}$/
                if (!regex.test(value)) {
                  this.model.orgIdCardNum = value.replace(/[^A-Z0-9]/g, '')
                }
              },
            },
          },
        },
        {
          el: 'input',
          itemConfig: {
            label: 'E签宝账号ID',
            prop: 'orgId',
          },
          render: () => {
            // eslint-disable-next-line @typescript-eslint/no-var-requires
            const imgUrl = require('@/assets/img/guide_e_sign_v3.png')
            return <el-form-item prop="orgId" label="E签宝账号ID:">
              <el-popover
                placement="top"
                trigger="hover"
              >
                  <div>登录e签宝开放平台（<a target="_blank" href="https://open.esign.cn/my-apps/home">https://open.esign.cn/my-apps/home</a>），切换到对应企业空间，复制账号ID</div>
                  <img src={imgUrl} style="width: 1146px; height: 267px" />
                  <i slot="reference" style="position: absolute; left: -18px; top: 8px" class="el-icon-question"></i>
              </el-popover>
              <el-input
                  style="width: 230px"
                  placeholder="请输入E签宝账号ID"
                  maxlength="32"
                  v-model={this.model.orgId}
              ></el-input>
            </el-form-item>
          },
        },
      ],
      model: {
        orgName: '',
        orgId: '',
        orgIdCardNum: '',
      },
      rules: {
        orgName: [
          { required: true, message: '请输入企业主体全称', trigger: 'blur' },
        ],
        orgIdCardNum: [
          { required: true, message: '请输入统一社会信用代码证号', trigger: 'blur' },
        ],
        orgId: [
          { required: true, message: '请输入E签宝账号ID', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    // eslint-disable-next-line vue/no-unused-properties
    submitAddOrg() {
      this.$refs.authFormRef.getRefs().validate(async (validate) => {
        if (validate) {
          const { code } = await addContractOrg(this.model)
          if (code === 1) {
            this.$emit('addContractOrgSucc', this.model.orgId)
          }
        }
      })
    },
  },
  mounted() {
    this.model.orgName = this.orgName
    this.model.orgIdCardNum = this.orgIdCardNum
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-form-item__label {
  padding: 0 22px 0 0;
}
</style>
